import * as React from 'react';

import { createIcon } from '../Icon';
export const BatteryIcon = createIcon(
  <React.Fragment>
    <rect height={12} rx={2} ry={2} width={18} x={1} y={6} />
    <line x1={23} x2={23} y1={13} y2={11} />
  </React.Fragment>,
  'BatteryIcon'
);
